import React from 'react';

import { ADD_COURSE_CONTEXT_ITEMS } from 'constants/common';

import { getDailyChallenges } from 'store/dailyChallenges/actions';

import { Loading } from 'components/shared/Loading';
import { Button } from 'components/shared/Button';
import { Icon } from 'components/shared/Icon';

import { MenuLayout } from 'components/Layout';
import { EmptyState } from 'components/EmptyState';
import { ListToolbar } from 'components/Toolbar';
import { DailyChallengesTable } from 'components/DailyChallengesTable';
import { CreateButton } from 'components/CreateButton';

import styles from './DailyChallengesPage.module.scss';

const DailyChallengesPage = ({
  loading,
  isRootAdmin,
  dailyChallenges,
  sortParams,
  columns,
  onSearchChange,
  onSortChange,
  onContextItemClick,
  onRowClick,
  onCreateClick,
  onRemoveClick,
  onEditClick,
}: {
  loading: any;
  isRootAdmin: any;
  dailyChallenges: any;
  sortParams: any;
  columns: any;
  onSearchChange: any;
  onSortChange: any;
  onContextItemClick: any;
  onRowClick: any;
  onCreateClick: any;
  onRemoveClick: any;
  onEditClick: any;
}) => {
  return (
    <MenuLayout>
      <ListToolbar
        title="Daily Challenges"
        actionComponent={
          isRootAdmin ? (
            <Button
              size="md"
              variant="link"
              startIcon={<Icon name="plusRound" />}
              onClick={onCreateClick}
            >
              Create Daily Challenge
            </Button>
          ) : (
            <CreateButton
              buttonText="Create Daily Challenge"
              contextItems={ADD_COURSE_CONTEXT_ITEMS}
              onContextItemClick={onContextItemClick}
            />
          )
        }
      />
      {loading ? (
        <Loading />
      ) : (
        <>
          {dailyChallenges.length ? (
            <div className={styles.inner}>
              <DailyChallengesTable
                params={sortParams}
                data={dailyChallenges}
                columns={columns}
                dataAction={getDailyChallenges}
                onSortChange={onSortChange}
                onSearchChange={onSearchChange}
                onRowClick={onRowClick}
                onRemoveClick={onRemoveClick}
                onEditClick={onEditClick}
              />
            </div>
          ) : (
            <EmptyState
              className={styles.emptyState}
              icon="trainings"
              title="No daily challenges yet"
              text="Create a daily challenge to get started."
            />
          )}
        </>
      )}
    </MenuLayout>
  );
};

export default React.memo(DailyChallengesPage) as any;
